(function() {
	'use strict';

	angular
		.module('assetCommon')
		.factory('userMapper', userMapper);

	function userMapper(_) {
		function mapUser(source) {
			if (!source)
				return undefined;

			if (_.isArray(source))
				return source.map(mapUser);

			return {
				id: source.id,
				token: source.token,
				name: source.name,
				avatarUri: source.avatarUri,
				isAnonymous: source.id === -1
			};
		}

		function mapUserDetails(source) {
			if (!source)
				return undefined;

			if (_.isArray(source))
				return source.map(mapUserDetails);

			return {
				id: String(source.id),
				token: source.profileToken && source.profileToken.value,
				email: source.email && source.email.value,
				name: source.name && source.name.value || source.alias && source.alias.value,
				avatarUri: source.avatarUrls && source.avatarUrls.value.avatarUrlLarge,
				about: source.about && source.about.value,
				organization: source.organization && source.organization.value,
				title: source.title && source.title.value,
				isAnonymous: source.id === -1
			};
		}

		return {
			map: mapUser,
			mapDetails: mapUserDetails
		};
	}
	userMapper.$inject = ['_'];
})();